import React from 'react';
import { iconForField } from '../custom/icon-library';

const CustomInputWithIconNoFormGroup = ({ icon, children, title, style, required }) => {
  return (
    <div className={`input-group ${style}`}>
      <div className="input-group-prepend" title={title}>
        <span className="input-group-text">
          <i className={`wb ${iconForField(icon)}`}></i>
          {required && <span className="required">*</span>}
        </span>
      </div>
      {children}
    </div>
  );
};

export default CustomInputWithIconNoFormGroup;
